import { render, staticRenderFns } from "./commonSlide.vue?vue&type=template&id=f4a4dfa8&scoped=true"
import script from "./commonSlide.vue?vue&type=script&lang=js"
export * from "./commonSlide.vue?vue&type=script&lang=js"
import style0 from "./commonSlide.vue?vue&type=style&index=0&id=f4a4dfa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a4dfa8",
  null
  
)

export default component.exports